import { Theme } from "@remo-co/ui-core/src/types";
import { makeStyles } from "@remo-co/ui-core/src/utils/makeStyles";

export const useStyles = makeStyles((theme: Theme) => ({
  icon: {
    marginInlineEnd: 5,
  },
  error: {
    color: theme.palette.status.error,
  },
  success: {
    color: theme.palette.green.action,
  },
}));
